import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Wrapper, FirstItem, DropDownIcon, ItemsList, Title,
} from './styles';

const ButtonsList = ({
  children, title, width, overlap, disabled, onToggle = () => null, open, dataTestid,
}) => {
  const [actionsOpen, udpateActionsOpen] = useState(false);
  const showItems = open || actionsOpen;

  const toggleOpen = () => {
    if (disabled) {
      return;
    }

    const newValue = !showItems;
    udpateActionsOpen(newValue);
    onToggle(newValue);
  };

  const hideMenu = () => {
    onToggle(false);
    udpateActionsOpen(false);
  };

  return (
    <Wrapper
      width={width}
      data-testid={dataTestid || 'buttons-list'}
    >
      <FirstItem open={showItems} onClick={toggleOpen} disabled={disabled} data-testid="buttons-list--open">
        <Title>{title || 'Actions'}</Title>
        <DropDownIcon>
          <FontAwesomeIcon icon="chevron-down" className="icon" />
        </DropDownIcon>
      </FirstItem>
      {(showItems) && (
        <ItemsList onClick={hideMenu} overlap={overlap}>
          {children}
        </ItemsList>
      )}
    </Wrapper>
  );
};


ButtonsList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  title: PropTypes.string,
  width: PropTypes.string,
  dataTestid: PropTypes.string,
  overlap: PropTypes.bool,
  disabled: PropTypes.bool,
  open: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default ButtonsList;
